export const appEmits = ["barTitle", "barMenuIcon", "barMenuList", "cacheClear", "login"];
